export const TITLE = "Electric Loading Auto Price in India 2026 - Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Check electric loading auto prices from ₹3.4 lakh. Explore electric 3 wheeler cargo, 4 wheeler loading auto with up to 180 km range at Turno.",
  },
  {
    name: "keywords",
    content:
      "Electric Cargo Vehicles, electric cargo auto, electric cargo rickshaw, electric cargo online, electric cargo price, electric cargo EMI, electric cargo financing, electric cargo test drive, Mahindra Treo, Piaggio E-Xtra, electric cargo range, electric cargo cost, electric cargo emissions, electric cargo running cost, electric cargo booking, electric cargo dealer, Turno electric cargo, electric cargo India, electric cargo specifications, electric cargo features",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/cargo",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/cargo",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Electric Loading Auto Price in India 2026 - Turno",
  },
  {
    property: "og:description",
    content:
      "Check electric loading auto prices from ₹3.4 lakh. Explore electric 3 wheeler cargo, 4 wheeler loading auto with up to 180 km range at Turno.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Check electric loading auto prices from ₹3.4 lakh. Explore electric 3 wheeler cargo, 4 wheeler loading auto with up to 180 km range at Turno.",
  },
  {
    name: "twitter:title",
    content: "Electric Loading Auto Price in India 2026 - Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/cargo",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/cargo";

export const H1_HEADING = "Electric Loading Auto";

export const ATF_CONTENT = {
  text: [
    "The demand for efficient Loading Auto vehicles in India has seen a massive surge in demand as businesses look to reduce operating and fuel costs and take the path of eco-friendly logistics. Independent operators and delivery fleet managers are moving to electric loading auto as it is a green choice and a smart financial investment.",
    "With a significantly lower electric loading auto price per kilometer compared to diesel, electric loading autos are completely changing the last-mile delivery. With top brands like ",
    ", and ",
    " offering electric loading autos, let's decode how to choose the right electric three wheeler cargo for your business.",
  ],
  automakers: [
    { name: "Mahindra", link: "/electric-commercial-vehicles/Mahindra" },
    { name: "Piaggio", link: "/electric-commercial-vehicles/Piaggio" },
    { name: "Bajaj", link: "/electric-commercial-vehicles/Bajaj/re-e-tec" },
  ],
  automakersIndex: 1, // Specify which text index should have automakers inserted
};

export const PRICING_TABLE_HEADING = "Electric Loading Auto Price List in India 2026";

export const PRICING_TABLE_COLUMNS = [
  { key: "model", label: "Model" },
  { key: "type", label: "Type" },
  { key: "gvw", label: "GVW (kg)" },
  { key: "topload", label: "Topload (kg)" },
  { key: "priceRange", label: "Price Range (Ex-Showroom)" },
];

export const PRICING_TABLE_DATA = [
  {
    model: "Mahindra Zor Grand",
    type: "3 Wheeler",
    gvw: "998 kg",
    topload: "550 kg",
    priceRange: "₹4.30 Lakh",
    link: "/electric-commercial-vehicles/Mahindra/Zor-Grand",
  },
  {
    model: "Mahindra Treo Zor",
    type: "3 Wheeler",
    gvw: "995 kg",
    topload: "550 kg",
    priceRange: "₹3.4 Lakh",
    link: "/electric-commercial-vehicles/Mahindra/Treo-Zor",
  },
  {
    model: "Piaggio Ape E-Xtra FX",
    type: "3 Wheeler",
    gvw: "975 kg",
    topload: "550 kg",
    priceRange: "₹3.89 Lakh",
    link: "/electric-commercial-vehicles/Piaggio/E-Xtra-FX",
  },
  {
    model: "Euler HiLoad EV",
    type: "3 Wheeler",
    gvw: "1413 kg",
    topload: "688 kg",
    priceRange: "₹4.14 Lakh",
    link: "/electric-commercial-vehicles/Euler/HiLoadDV",
  },
  {
    model: "Montra Super",
    type: "3 Wheeler",
    gvw: "749 kg",
    topload: "580 kg",
    priceRange: "₹3.76 Lakh",
    link: "/electric-commercial-vehicles/Montra/super-auto",
  },
];

export const SEO_FOOTER_CONTENT = [
  {
    heading: "About Loading Auto: The Backbone of Last-Mile Delivery",
    paragraphs: [
      "An electric loading auto, often referred to as an electric three wheeler cargo or electric loading tempo, is a high-torque commercial vehicle designed to transport goods across short to medium distances. A loading auto features a reinforced chassis and a spacious cargo bed (available as a flatbed, pickup, or delivery van) which is used to haul heavy payloads of cargo. This is the opposite of passenger autos which use a seating arrangement style load to carry passengers",
      "In 2026, the market demand has risen beyond simple e-rickshaws. Today's electric load auto models come with advanced telematics, strong Lithium-ion batteries, and regenerative braking, ensuring a hassle-free logistical commute. With the electric loading auto price becoming more competitive due to government subsidies like EMPS 2026, switching from a diesel ape load auto to an electric version can save an operator up to ₹1.2 Lakh annually that too in just fuel prices.",
    ],
  },
  {
    heading: "3 Wheeler Loading Auto Price in India 2026",
    paragraphs: [
      "The 3 wheeler loading auto price varies depending on the battery capacity and load carrying capacity. For entry-level models like the Mahindra load auto (e-Alfa Cargo), prices start as low as ₹1.60 Lakh. However, high-speed L5 category vehicles like the Mahindra Zor Grand or Bajaj auto loading models typically range between ₹3.50 Lakh and ₹4.80 Lakh, demanding a premium price for their premium offerings.",
    ],
    list: [
      {
        label: "L3 Category (E-Rickshaw Loaders)",
        text: "Best for light loads (300-400kg) and short distances.",
      },
      {
        label: "L5 Category (High-Speed Cargo)",
        text: "These offer higher speeds (45-55 kmph) and are better suited for heavy-duty commercial work, justifying a higher loading auto price.",
      },
    ],
  },
  {
    heading: "4 Wheeler Loading Auto Price in India 2026",
    paragraphs: [
      "For businesses requiring more stability and higher payload capacities, the 4 wheeler loading auto price starts from approximately ₹7.5 Lakh. The loading auto 4 wheeler segment is dominated by the Tata Ace EV and the newly launched Mahindra Zeo. While the 4 wheeler loading auto price is higher than its 3-wheeled counterparts, they offer a \"mini-truck\" experience with payloads reaching up to 750kg and enhanced safety features like ADAS in premium variants.",
    ],
  },
  {
    heading: "Top Loading Auto Brands in India",
    subSections: [
      {
        heading: "1. Mahindra Last Mile Mobility",
        paragraphs: [
          "Mahindra leads the market with the Mahindra load auto range. The Mahindra Zor Grand price offers excellent value for a vehicle with a 150+ km range.",
        ],
      },
      {
        heading: "2. Piaggio",
        paragraphs: [
          "The ape load auto has been a household name for decades. Its electric avatar, the Ape E-Xtra, is known for its rugged build and reliable performance in narrow city lanes.",
        ],
      },
      {
        heading: "3. Bajaj Auto",
        paragraphs: [
          "The Bajaj auto loading (Maxima XL Cargo) is a top contender for those prioritizing range, offering one of the highest certified ranges in the 3-wheeler segment at 183 km.",
        ],
      },
      {
        heading: "4. Euler Motors",
        paragraphs: [
          "The Euler HiLoad EV is specifically designed for heavy-duty micro-logistics, offering a class-leading payload and a unique chassis-integrated battery.",
        ],
      },
    ],
  },
  {
    heading: "How to Select the Best 3 Wheeler Loading Auto",
    paragraphs: [
      "Choosing the right electric loading tempo requires balancing your budget with operational needs. Consider these factors:",
    ],
    list: [
      {
        label: "Payload Capacity",
        text: "Ensure the loading auto can handle your daily weight requirements (typically 500kg for 3-wheelers).",
      },
      {
        label: "Range per Charge",
        text: "Calculate your daily distance. A loading auto price for a 150km range model will be higher than an 80km range model.",
      },
      {
        label: "Charging Time",
        text: "Does the vehicle support fast charging? This is crucial for double-shift operations.",
      },
      {
        label: "After-Sales Service",
        text: "Brands like Mahindra and Piaggio have wider service networks, ensuring your electric load auto stays on the road.",
      },
    ],
  },
  {
    heading: "Benefits of Choosing Turno for Loading Auto",
    paragraphs: [
      "Turno is not just a marketplace; we are your growth partner in the EV journey. Buying your loading auto through Turno offers unique advantages:",
    ],
    list: [
      {
        label: "Guaranteed Resale Value",
        text: "We offer a pre-determined buyback price, so you never have to worry about the future value of your EV.",
      },
      {
        label: "Lowest Interest Rates",
        text: "Get an electric 3 wheeler cargo price financed at just 10.5% interest.",
      },
      {
        label: "Turno One App",
        text: "Track your battery health, range, and earnings in real-time.",
      },
      {
        label: "Multi-Brand Choice",
        text: "Compare the loading auto price across Mahindra, Piaggio, Euler, and more in one place.",
      },
    ],
  },
];

export const CARGO_FAQS = [
  {
    question: "What is an electric cargo vehicle or loading auto rickshaw?",
    answer:
      "An electric cargo vehicle is a battery-operated three or four-wheeler which is designed specifically for the transportation of goods. Instead of relying on diesel or CNG fuel, these loading vehicles use stored electricity which powers an electric motor to move.",
  },
  {
    question: "What is the on road price of 3 wheeler Loading auto?",
    answer:
      "The 3 wheeler loading auto price on-road typically ranges between ₹3.8 Lakh and ₹5.2 Lakh, which includes insurance and registration, and after deducting subsidies provided by the government.",
  },
  {
    question: "What is the price of 250 km range loading auto?",
    answer:
      "Many of the 3-wheeler cargo EVs that are sold in India offer a range between 120-180 km. The highest operational range is offered by Altigreen Neev is a premium, high range model that can cover up to 120 km on a single charge. Its price range in India starts at around Rs. 4.26 Lakh (ex-showroom).",
  },
  {
    question: "What is the battery life of an electric 3 wheeler?",
    answer:
      "Electric auto battery packs can usually last between 3000 and 5000 charging cycles, estimating a rough lifespan of approximately 5 to 7 years of usage without requiring a replacement battery.",
  },
  {
    question: "What is the running cost of an electric 3 wheeler in India?",
    answer:
      "Electric 3 wheelers provide a low running cost of about 40 – 60 paise per kilometer. When compared to the 4 to 5 Rupee per kilometer of diesel vehicles, electric three wheelers are very cost effective.",
  },
  {
    question: "What is the avg load-carrying capacity of an electric loading rickshaw?",
    answer:
      "3-wheeler loading autos are usually able to carry a payload of around 450 kg and 600 kg. On the other hand, 4-wheeler models can carry up to 750 kg - 1000 kg easily.",
  },
  {
    question: "Do electric rickshaws require a driving license and registration?",
    answer:
      "Yes, all high-speed L5 and L5N category loading auto models require a valid commercial driving license and RTO registration.",
  },
];

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Electric Loading Auto" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Electric Loading Auto",
      item: VEHICLE_LINK,
    },
  ],
};